<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";
export default {
  mixins: [userPower],
  components: {
    pageTemplate,
  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 12,
            data: [],
            url: api.store.store,
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "startTime",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "用户名称",
            prop: "name",
            type: "input",
            ifFuzzy: true,
            span: 12,
            placeholder: "请输入用户名称",
          },
          {
            label: "模块",
            prop: "name",
            type: "input",
            ifFuzzy: true,
            span: 12,
            placeholder: "请输入模块,模糊匹配",
          },
          {
            label: "操作员",
            prop: "name",
            type: "input",
            ifFuzzy: true,
            span: 12,
            placeholder: "请输入操作员",
          },
          {
            label: "功能",
            prop: "name",
            type: "input",
            ifFuzzy: true,
            span: 12,
            placeholder: "请输入功能,模糊匹配",
          },

        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: "设置",
          code: "set",
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "编辑",
          code: "update",
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "设置",
          code: "set",
          type: this.$utils.buttonType.tableOperate,
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {
            label: "门店",
            prop: "storeName",
            width: "120",
            align: "center",
          },
          { label: "操作模块", prop: "module", width: "120", align: "center" },
          {
            label: "描述",
            prop: "describeStr",
            width: "150",
            align: "center",
          },
          {
            label: "操作类型",
            prop: "operationType",
            width: "150",
            align: "center",
          },
          {
            label: "操作人",
            prop: "userName",
            width: "120",
            align: "center",
          },
          // {
          //   label: "返回值",
          //   prop: "returnValue",
          //   width: "150",
          //   align: "center",
          // },
          {
            label: "操作时间",
            prop: "lastModifyDttm",
            width: "150",
            align: "center",
          },
          // {
          //   label: "备注",
          //   prop: "remarks",
          //   width: "150",
          //   align: "center",
          // },
        ],
        url: api.system.log,
      },
    };
  },
  created() {
    this.setStore(this.searchOptions.simple);
  },
  methods: {},
};
</script>




// WEBPACK FOOTER //
// src/page/system/maintain/Log.vue